var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@at/sauron-platform-graphql';
import { ShowroomLite } from '@at/design-system-collections';
import { Banner, LeaseType, VehicleCard, VehicleTypes } from '@at/design-system-patterns';
import { vehicleCardCollectionLiteQuery } from './query/vehicle-card-collection-lite.query';
import { mapGQLAdDataToVehicleCards } from './utils/map-gql-ad-data-to-vehicle-cards';
import { makeStringSingular } from '@at/formatter-utils/lib/string-utils/string.utils';
import { LeaseContractType } from './__generated__/graphql-types';
import { Channel } from '@at/sauron-platform-core';
export const ConnectedVehicleCardCollectionLite = ({ channel, className, gqlQueryVars, vehicleType, customVehicleCardData, additionalVehicleCardData, showroomLiteProperties, shouldRenderComponentWithNoResults = true, queryParams, deliveryEstimateBadge = false, }) => {
    // In order to make this component work locally it requires a header to be attached e.g "x-sauron-app-name: sauron-adverts-app" or temporarily remove one field that you don't need (imageList works) as GQL requests without app names default to complexity limit of 50
    //we are expecting to change the way we approach complexity limit when GQL is reworked
    const { data, loading, error, networkStatus } = useQuery(vehicleCardCollectionLiteQuery, {
        variables: gqlQueryVars,
        errorPolicy: 'all',
    });
    // https://www.apollographql.com/docs/react/api/react/hoc/#datanetworkstatus
    const isQueryStatusReady = networkStatus === 7;
    const vehicleCardData = customVehicleCardData;
    const { isLoading: showroomLightPropertiesIsLoading } = showroomLiteProperties, restShowroomLightProperties = __rest(showroomLiteProperties, ["isLoading"]);
    const toProductPageAdvertPart = (channel) => {
        switch (channel) {
            case Channel.cycles:
                return 'electric-bike';
            case Channel.plant:
                return 'plant-machinery';
            case Channel.farm:
                return 'farm-machinery';
            default:
                return makeStringSingular(channel);
        }
    };
    const advertPath = vehicleType === VehicleTypes.LEASE ? channel : toProductPageAdvertPart(channel);
    const showFullLeaseOption = gqlQueryVars.leaseOption === 'cheapest';
    const connectedVehicleCardData = mapGQLAdDataToVehicleCards({
        advertPath,
        data,
        vehicleType,
        vehicleCardData,
        additionalVehicleCardData: Object.assign(Object.assign({ showFullLeaseOption }, additionalVehicleCardData), (gqlQueryVars.leaseContractType && {
            leaseType: gqlQueryVars.leaseContractType === LeaseContractType.personal
                ? LeaseType.PERSONAL
                : LeaseType.BUSINESS,
        })),
        queryParams,
        deliveryEstimateBadge,
    });
    if (error) {
        return (_jsx(Banner, Object.assign({ variation: "error", title: "Error" }, { children: "Sorry, there was a problem displaying these items. Please try again later." })));
    }
    const noItemsToDisplay = !connectedVehicleCardData.length;
    const isLoading = Boolean((loading && noItemsToDisplay && !isQueryStatusReady) || showroomLightPropertiesIsLoading);
    if (!shouldRenderComponentWithNoResults && noItemsToDisplay) {
        return null;
    }
    return (_jsx(ShowroomLite, Object.assign({ className: className !== null && className !== void 0 ? className : '', isLoading: isLoading }, restShowroomLightProperties, { children: connectedVehicleCardData.map((card, index) => (_jsx(VehicleCard, Object.assign({}, card, { containerTag: "div", scrollSnapPosition: "none", maxWidth: "300px", badgeItems: card.badgeItems }), `vehicle-card-${index}`))) })));
};
